import { type Ref } from 'react'
import { observer } from 'mobx-react-lite'
import { InfiniteScrollLoaderContainer } from '@/components/InfiniteScrollLoader/InfiniteScrollLoaderContainer'
import { ContentError } from '@/components/ContentError'
import type { InfiniteScrollProvider } from '@/infra/InfiniteScrollProvider'

export type OnPressItemRow<S> = (item: S) => unknown

export interface VirtuosoContext<S> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- InfiniteScrollProvider is invariant in its filter type, which the table never reads
  scroller: InfiniteScrollProvider<S, any>
  onPressItemRow?: OnPressItemRow<S>
}

interface VirtualTableInfiniteScrollLoaderContainerProps<S> {
  context?: VirtuosoContext<S>
  ref?: Ref<HTMLTableSectionElement>
}

/**
 * Table Infinite Scroll Loader. Created by the TableVirtuoso component.
 */
export const VirtualTableInfiniteScrollLoaderContainer = observer(
  function VirtualTableInfiniteScrollLoaderContainer<S>({
    context,
    ref,
  }: VirtualTableInfiniteScrollLoaderContainerProps<S>) {
    const scroller = context?.scroller
    if (!scroller) {
      // The typing in Virtuoso says it can be undefined, but we know that we
      // pass it in.
      return null
    }

    return (
      <tfoot ref={ref}>
        <tr>
          {/* The error/loading state wants to span the entire table */}
          <td colSpan={100}>
            {scroller.fetch.error ? (
              <ContentError error={scroller.fetch.error} />
            ) : !scroller.isDone ? (
              <InfiniteScrollLoaderContainer scrollProvider={scroller} />
            ) : null}
          </td>
        </tr>
      </tfoot>
    )
  },
)
